import React from 'react';
import { Avatar, AvatarSize, Text, TextButton, TextButtonPriority, HoverStyles, } from 'wix-ui-tpa/cssVars';
import { useTranslate } from '../../../../context/api-context/translations/use-translate';
import { useRemainingWidth } from '../use-remaining-width/use-remaining-width';
import { classes } from './comment-box-outer-footer.st.css';
import { useApi } from '../../../../api-provider';
import { LOGIN_AS_MEMBER_BTN } from '../../../../../common/constants/data-hooks';
export const CommentBoxOuterFooter = ({ publishControls, currentMember, isMobile, }) => {
    const { maxWidth, containerRef, elementRef } = useRemainingWidth();
    const t = useTranslate();
    const { requestLoginAction } = useApi((_, actions) => ({
        requestLoginAction: actions.requestLogin,
    }));
    return (React.createElement("div", { className: classes.root, ref: containerRef },
        currentMember?.profile ? (React.createElement("div", { className: classes.commentingAs, ref: elementRef },
            React.createElement(Avatar, { className: classes.avatar, size: AvatarSize.xSmall, src: currentMember.profile.photo?.url }),
            React.createElement("div", { className: classes.name }, t('comment-box-footer.commenting-as', {
                name: currentMember.profile.nickname,
            })))) : (React.createElement("div", { className: classes.container },
            React.createElement(TextButton, { "data-hook": LOGIN_AS_MEMBER_BTN, className: classes.textButton, priority: TextButtonPriority.primary, onClick: () => requestLoginAction({ mode: 'login' }), hoverStyle: HoverStyles.underline }, t('comment-box-footer.log-in')),
            "\u00A0",
            React.createElement(Text, { className: classes.text }, t('comment-box-footer.to-publish-as-member')))),
        !isMobile && (React.createElement("div", { className: classes.publishControls, style: { maxWidth: maxWidth ?? 'auto' } }, publishControls))));
};
//# sourceMappingURL=comment-box-outer-footer.js.map